module.exports = __webpack_public_path__ + "img/bg.1630993415105.png";